export default "__VITE_ASSET__DBKossTH__"